module.exports = __webpack_public_path__ + "img/user.9ebfdab7.png";